
import { computed, defineComponent, PropType } from 'vue'
import { IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonContent, IonSkeletonText } from '@ionic/vue'
import { useStore } from 'vuex'
import { displayOnlySignificatDigits } from '@/services/FormatValue'
import { ArbitrageDetails } from '@/store/modules/assets/models/estimation/ArbitrageDetails'
import { convertCurrency } from '@/services/ConvertCurrency';
import AssetSummary from '@/store/modules/assets/models/estimation/AssetSummary'
import usePrivacyMode from '@/hooks/usePrivacyMode'
import useCurrency from '@/hooks/useCurrency'

export default defineComponent({
    name: 'EstimationPortfolioModal',
    components: { IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonContent, IonSkeletonText },
    props: {
      title: {
        type: String,
        required: true
      },
      assetsSummary: {
        type: Array as PropType<AssetSummary[]>,
        required: true
      },
      percentageOfPortfolio: {
        type: Number,
        required: true
      }
    },
    emits: ['onDismiss'],
    setup(props, { emit }) {
        const dismiss = () => {
            emit('onDismiss', false)
        }        
        const store = useStore()
        const { preferredCurrency, currencyRate, baseCurrencyRate } = useCurrency()
        const isEstimationLoading = computed(() => store.getters.isEstimationLoading)
        const SKELETON_ITEMS = 4

        const tableHeaders = computed(() => ['asset', 'quantity', `price [${preferredCurrency.value}]`, `value [${preferredCurrency.value}]`, `nettoValue [${preferredCurrency.value}]`, `value ${props.percentageOfPortfolio * 100}% [${preferredCurrency.value}]`, `nettoValue ${props.percentageOfPortfolio * 100}% [${preferredCurrency.value}]`, 'exchange name', 'arbitrage'])

        const sumColumnValues = (array: AssetSummary[], key: string) => array.reduce((acc, elem) => acc + (elem as any)[key], 0)
        const sumValues = computed(() => sumColumnValues(props.assetsSummary, 'value'))
        const sumNettoValues = computed(() => sumColumnValues(props.assetsSummary, 'nettoValue'))
        const sumPercentageValue = computed(() => sumColumnValues(props.assetsSummary, 'percentageValue'))
        const sumPercentageNettoValue = computed(() => sumColumnValues(props.assetsSummary, 'percentageNettoValue'))
        const sumCells = computed(() => ['Sum', '', '', sumValues.value, sumNettoValues.value, sumPercentageValue.value, sumPercentageNettoValue.value, '', ''])

        const displayProp = (prop: number | string | ArbitrageDetails, key: string) => {
          if (typeof prop === 'number') {
            if(key == 'quantity') {
              return  displayOnlySignificatDigits(prop, 6)
            }
            return displayOnlySignificatDigits(convertCurrency(prop, baseCurrencyRate.value, currencyRate.value), 6)
          } else if (typeof prop === 'object' && typeof prop !== 'string') {
            if (Object.keys(prop).length !== 0) {
              return `${prop.exchangeMarkets[0]}->${prop.exchangeMarkets[1]} ${prop.market} +${displayOnlySignificatDigits(convertCurrency(prop.profit, baseCurrencyRate.value, currencyRate.value), 6)} ${prop.market.split('-')[1]}`
            } else return 'not possible'
          } else return prop
        }

        const { PRIVACY_MASK, isPrivacyModeActive } = usePrivacyMode()
        
        return { dismiss, isEstimationLoading, tableHeaders, SKELETON_ITEMS, displayOnlySignificatDigits, displayProp, sumCells, PRIVACY_MASK, isPrivacyModeActive }
    }
})
